import React, { useEffect, useState } from 'react';
import { NotificationType } from '../App';
import { XIcon } from './Icons';

interface NotificationProps {
  message: string;
  type: NotificationType;
  onClose: () => void;
}

const Notification: React.FC<NotificationProps> = ({ message, type, onClose }) => {
  const [exiting, setExiting] = useState(false);

  const baseClasses = "fixed top-5 left-1/2 -translate-x-1/2 w-full max-w-md p-4 rounded-lg shadow-lg text-white z-[100] transition-all duration-300";
  const typeClasses = {
    success: 'bg-[var(--notif-success-bg)]',
    error: 'bg-[var(--notif-error-bg)]',
    info: 'bg-[var(--notif-info-bg)]',
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 4500); // Start fade out before auto-dismiss in App.tsx

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setExiting(true);
    setTimeout(onClose, 300); // Allow time for fade-out animation
  };

  return (
    <div className={`${baseClasses} ${typeClasses[type]} ${exiting ? 'opacity-0' : 'opacity-100'} notification`}>
      <div className="flex items-center justify-between">
        <p className="font-medium">{message}</p>
        <button onClick={handleClose} className="p-1 rounded-full hover:bg-white/20">
          <XIcon />
        </button>
      </div>
    </div>
  );
};

export default Notification;